export interface Resource {
  id: string;
  type: "RDT Kit" | "ACT Drug" | "LLIN Net" | "Personnel" | "Vehicle" | "Medical Equipment";
  name: string;
  quantity: number;
  unit: string;
  districtId: string;
  districtName: string;
  organizationId: string;
  organizationName: string;
  lastUpdated: string;
  minThreshold: number;
  predictedDemand: number;
  gap: number;
}

const resourceTypes: ("RDT Kit" | "ACT Drug" | "LLIN Net" | "Personnel" | "Vehicle" | "Medical Equipment")[] = [
  "RDT Kit", "ACT Drug", "LLIN Net", "Personnel", "Vehicle", "Medical Equipment",
];

const units: Record<string, string> = {
  "RDT Kit": "kits",
  "ACT Drug": "blister packs",
  "LLIN Net": "nets",
  "Personnel": "staff",
  "Vehicle": "units",
  "Medical Equipment": "sets",
};

const names: Record<string, string[]> = {
  "RDT Kit": ["Standard RDT Kit", "Pf/Pv Combo RDT", "Ultra-Sensitive RDT", "Field RDT Pack", "Bulk RDT Container"],
  "ACT Drug": ["Artemether-Lumefantrine", "Artesunate-Amodiaquine", "Dihydroartemisinin-Piperaquine", "Artesunate-Mefloquine", "Injectable Artesunate"],
  "LLIN Net": ["PermaNet 3.0", "Olyset Plus", "Interceptor Net", "MagNet Long-Lasting", "Royal Guard Net"],
  "Personnel": ["Community Health Worker", "Lab Technician", "Vector Control Specialist", "Epidemiologist", "Field Supervisor"],
  "Vehicle": ["4x4 Pickup Truck", "Motorcycle Ambulance", "Refrigerated Van", "Spray Truck", "Mobile Clinic Unit"],
  "Medical Equipment": ["Microscope Set", "PCR Thermal Cycler", "Cold Chain Container", "Blood Bank Refrigerator", "Rapid Diagnostic Reader"],
};

const districtNames: Record<string, string> = {
  D01: "Yaoundé Central", D02: "Douala Metropolitan", D03: "Bamenda Urban",
  D04: "Maroua Central", D05: "Bafoussam Central", D06: "Garoua Urban",
  D07: "Kumba Central", D08: "Nkongsamba Urban", D09: "Bertoua Central",
  D10: "Edéa Metropolitan", D11: "Kousséri Urban", D12: "Ngaoundéré Central",
  D13: "Limbe Metropolitan", D14: "Buea Central", D15: "Foumban Urban",
  D16: "Ebolowa Central", D17: "Dschang Urban", D18: "Kribi Coastal",
  D19: "Guider Urban", D20: "Mbalmayo Central",
};

const orgs = [
  { id: "ORG001", name: "Ministry of Public Health" },
  { id: "ORG002", name: "MSF Cameroon" },
  { id: "ORG003", name: "Malaria Consortium" },
];

function generateResources() {
  const data: Resource[] = [];
  let idCounter = 1;
  const districtIds = Object.keys(districtNames);

  for (const dId of districtIds) {
    // Each district gets 2-4 resources of different types
    const numResources = 2 + Math.floor(Math.random() * 3);
    const selectedTypes = [...resourceTypes].sort(() => Math.random() - 0.5).slice(0, numResources);
    const org = orgs[Math.floor(Math.random() * orgs.length)];

    for (const type of selectedTypes) {
      const name = names[type][Math.floor(Math.random() * names[type].length)];
      const baseQuantity = type === "Personnel" ? 5 + Math.floor(Math.random() * 25) : 50 + Math.floor(Math.random() * 950);
      const minThreshold = Math.round(baseQuantity * 0.2);
      const predictedDemand = Math.round(baseQuantity * (0.8 + Math.random() * 0.6));
      const gap = Math.max(0, predictedDemand - baseQuantity);

      data.push({
        id: `RES-${String(idCounter++).padStart(5, "0")}`,
        type,
        name,
        quantity: baseQuantity,
        unit: units[type],
        districtId: dId,
        districtName: districtNames[dId],
        organizationId: org.id,
        organizationName: org.name,
        lastUpdated: `2025-05-${String(1 + Math.floor(Math.random() * 8)).padStart(2, "0")}`,
        minThreshold,
        predictedDemand,
        gap,
      });
    }
  }

  return data;
}

export const resources = generateResources();